import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Cookies: FC<SvgIconProps> = ({ viewBox = '0 0 259 200', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props}>
    <circle cx="129.586" cy="100" r="100" fill="#F7F7F7" />
    <path
      fill="#C8C9C8"
      d="M183.081 124.662c3.145 3.934-.943 7.972-6.499 10.975-5.66 3.003-12.369 2.899-13.941 0-.943-1.76.105-4.349 2.097-6.316 2.62-2.692 5.555-3.313 7.756-4.763 1.992-1.346 3.459-2.795 4.822-3.002 2.306-.621 4.193.932 5.765 3.106ZM146.709 80.9679l7.023 48.1461-20.964 2.588c-.629.104-1.153.104-1.782.104-6.813.31-6.813.31-7.757.414-4.402.103-9.014-.104-12.788-.104l-5.031-.517c-2.621-.415-5.9748-.829-7.9663-2.485-1.782-1.45-2.7254-5.177-3.6687-7.455-3.7736-9.526-3.1447-20.294.5241-29.923.2096-.5177.4192-1.0354.6289-1.6566 3.1446-8.2832 10.587-14.2885 19.497-15.6345h.314c5.765-.9318 11.635.1036 16.562 2.8991l.524.3107c2.201 1.2424 4.297 2.7955 6.708 3.3132 2.621.6212 5.556.2071 8.176 0Z"
    />
    <path
      fill="#B8B8B8"
      d="M111.804 123.522c-2.411-.518-4.926-.414-7.232.518-4.088 1.656-7.9668 4.97-7.1282 5.591 0 0 .3145.311 0 0 1.9916 1.657 5.2412 2.071 7.9662 2.485l5.032.518c3.773 0 8.385.207 12.788.103.943 0 .943 0 7.651-.414.629 0 1.154-.104 1.782-.104l15.933-.931 10.377-1.657 3.25-3.935-12.683 3.314.524 1.553-13.627-17.498-5.136 6.523c-1.677 1.76-5.975 4.555-8.176 5.487-1.887.725-4.088 1.036-7.757-.518-.524-.207-1.048-.414-1.572-.517l-1.992-.518ZM179.832 121.866c.629 1.139-4.612 5.074-8.071 8.594-3.249 3.313-6.918 2.485-7.757.621-.733-1.864.944-3.313 5.451-5.28 5.346-2.278 9.644-5.281 10.377-3.935Z"
    />
    <path
      fill="#B8B8B8"
      fillRule="evenodd"
      d="M126.491 75.2618c-3.737-1.1655-7.769-1.4606-11.752-.8169h-.314c-8.574 1.2953-15.7887 6.905-19.1228 14.7071.5852 4.6214 5.4138 7.7655 12.1988 6.4068 11.275-2.2387 17.802-16.5336 18.99-20.297Z"
      clipRule="evenodd"
    />
    <path
      fill="#B8B8B8"
      d="M119.036 117.828c4.631 0 8.385-3.06 8.385-6.834 0-3.774-3.754-6.833-8.385-6.833-4.632 0-8.386 3.059-8.386 6.833s3.754 6.834 8.386 6.834Z"
    />
    <path
      fill="#E4E4E4"
      d="m180.461 92.6674-8.176-8.076 6.813-7.869c1.782-1.1389 2.202.5177 2.202 3.2097l-.839 12.7353Z"
    />
    <path
      fill="#C8C8C8"
      d="m178.993 88.8372-4.507-4.7628 3.669-4.2451c.838-.7248 1.362-.6212 1.362 1.4496l-.524 7.5583Z"
    />
    <path fill="#B8B8B8" d="m178.994 88.8371-.42-9.3185c.315-.2071.944-.3106.944 1.7601l-.524 7.5584Z" />
    <path
      fill="#E4E4E4"
      d="M160.231 129.735c14.414 0 26.1-11.867 26.1-26.506s-11.686-26.5062-26.1-26.5062c-14.415 0-26.101 11.8672-26.101 26.5062s11.686 26.506 26.101 26.506Z"
    />
    <path
      fill="#E4E4E4"
      d="m144.612 88.733 9.749-6.0052-5.87-6.3159c-1.782-1.5531-3.564-.7248-3.774 1.6566l-.105 10.6645Z"
    />
    <path
      fill="#C8C8C8"
      d="m146.604 87.4906 6.394-3.9345-3.878-4.1415c-1.153-.9319-2.306-.4142-2.411 1.0354l-.105 7.0406Z"
    />
    <path
      fill="#B8B8B8"
      d="m150.692 85.1098 2.306-1.553-3.878-4.1416c-1.153-.9319-1.887-.2071-1.887-.2071 1.153.2071 1.991.8283 2.306 2.1743 0 0 .105.5177.21.7248l.943 3.0026Z"
    />
    <path
      fill="#C8C8C8"
      d="M180.397 91.7256c1.641-3.2813-1.068-7.9123-6.051-10.3436-4.983-2.4314-10.353-1.7423-11.993 1.539-1.641 3.2813 1.068 7.9123 6.051 10.3436 4.982 2.4314 10.352 1.7423 11.993-1.539ZM173.543 108.51c.315 0 .629-.104.839-.104h1.991c.42 0 .839.104 1.258.104.315.103.734.103 1.048.207l1.049.207.104-.414-1.048-.207c-.314-.104-.734-.104-1.048-.208h-.21c-.314 0-.733-.103-1.048-.103h-1.991c-.42 0-.839.103-1.258.103l-.734.104c-.314 0-.629.104-.943.207l-.315.104c-.419.103-.838.207-1.258.414l-.419.207.105.207v.207h1.467c.629.104 1.258.104 1.887.311.419.103.734.103 1.153.207l.419.103c.629.207 1.258.414 1.887.622h.105c.629.207 1.258.517 1.887.828l.734.414.209-.414-.943-.518c-.524-.207-1.048-.518-1.573-.725l-.419-.207-1.887-.621-.314-.104c-.419-.103-.943-.207-1.363-.31l-.733-.104-.944-.103.839-.311 1.467-.103ZM157.611 108.923c-.315 0-.629-.103-.839-.103h-1.991c-.42 0-.839.103-1.258.103-.315.104-.734.104-1.048.207l-2.097.725-.21-.414 2.202-.725c.314-.104.733-.104 1.048-.207h.21c.314 0 .733-.104 1.048-.104h1.991c.42 0 .839.104 1.258.104l.734.103c.314 0 .629.104.943.208l.315.103c.419.104.838.207 1.258.414l.419.207-.105.207v.207h-1.467c-.629.104-1.258.104-1.887.311-.419.104-.734.104-1.153.207l-.42.104c-.628.207-1.257.414-1.886.621h-.105c-.629.207-1.258.518-1.887.828l-.838.518-.21-.414 1.048-.621c.524-.208 1.048-.518 1.572-.725l.42-.207c.629-.207 1.258-.414 1.886-.622l.315-.103c.419-.104.943-.207 1.363-.311l.733-.103.944-.104-.839-.31-1.467-.104Z"
    />
    <path
      fill="#8E8E8E"
      d="M173.543 110.787c-.21-.104-.42 0-.42.207 0 .104-.524 1.76-2.83 2.278s-3.459-.725-4.193-1.967c0 0-.104 0-.104-.104 0 0 0-.103-.105-.103h-.21s0 .103-.105.103c0 0-.105 0-.105.104 0 .103-.629 1.76-3.144 2.278-2.621.517-3.879-.725-4.717-1.968-.105-.207-.315-.207-.524-.103-.21.103-.21.31-.105.517.839 1.139 1.992 2.382 4.193 2.382.419 0 .838 0 1.258-.104 1.991-.414 3.039-1.449 3.459-2.174.733.932 1.782 1.967 3.564 1.967.314 0 .733 0 1.048-.103 2.725-.518 3.354-2.692 3.354-2.796 0-.103-.105-.31-.314-.414Z"
    />
    <path fill="#D20612" d="M162.223 107.577h6.708l-3.144 3.728" />
    <path
      fill="#000"
      d="M156.667 101.987c0 1.035-.734 1.76-1.677 1.76-.943 0-1.677-.828-1.677-1.76 0-1.036.734-1.76 1.677-1.76.943 0 1.677.724 1.677 1.76ZM175.639 101.987c0 1.035-.733 1.76-1.677 1.76-.943 0-1.677-.828-1.677-1.76 0-1.036.734-1.76 1.677-1.76.944 0 1.677.724 1.677 1.76Z"
    />
    <path
      fill="#C8C9C8"
      d="M93.7738 115.135s-14.4652 4.246-15.3037 18.845c0 0-1.153 14.184 17.8194 17.084 0 0 18.7625 4.141 20.2305-5.384 0 0 1.153-11.079-7.023-9.112-3.354.518-9.5388.828-12.1593-.414 0 0-3.9831-2.796.8386-7.558l-4.4025-13.461Z"
    />
    <path
      fill="#B8B8B8"
      d="M101.637 125.801s-12.4739 1.242-10.063 8.283c0 0 1.0482 2.588 7.547 2.692 0 0-1.5723-.311-2.2012-.932-.9434-.932-2.2012-3.21.5241-6.523 0 0 2.8301-2.796 4.1931-3.52Z"
    />
    <path
      fill="#D88D5B"
      fillRule="evenodd"
      d="M168.698 123.851c-.555.112-1.129.171-1.718.171-4.125 0-7.559-2.901-8.289-6.734-6.713 1.379-11.737 6.966-11.737 13.648 0 7.718 6.701 13.974 14.967 13.974 8.266 0 14.967-6.256 14.967-13.974 0-.07-.001-.139-.002-.209.001-.068.002-.135.002-.203 0-.554-.036-1.101-.105-1.638-.105.004-.211.006-.317.006-3.492 0-6.488-2.079-7.768-5.041Z"
      clipRule="evenodd"
    />
    <path
      fill="#E7B267"
      fillRule="evenodd"
      d="M168.766 123.712c-.621.15-1.271.23-1.94.23-4.024 0-7.36-2.886-7.968-6.659-6.436 1.309-11.255 6.66-11.255 13.062 0 7.383 6.41 13.368 14.318 13.368 7.908 0 14.318-5.985 14.318-13.368 0-.067 0-.134-.001-.201.001-.064.001-.129.001-.194 0-.384-.018-.764-.053-1.14-3.394-.05-6.28-2.154-7.42-5.098Z"
      clipRule="evenodd"
    />
    <ellipse cx="153.067" cy="135.244" fill="#7C511C" rx="2.108" ry="1.90556" />
    <ellipse cx="160.867" cy="128.68" fill="#7C511C" rx="3.79441" ry="3.38765" />
    <ellipse cx="161.815" cy="139.796" fill="#7C511C" rx=".7378" ry=".74105" />
    <path
      fill="#7C511C"
      fillRule="evenodd"
      d="M171.244 127.058c-.031.077-.048.16-.048.246 0 .409.378.741.843.741.189 0 .364-.055.504-.147-.461-.239-.896-.521-1.299-.84Z"
      clipRule="evenodd"
    />
    <ellipse cx="156.018" cy="122.011" fill="#7C511C" rx=".8432" ry=".95278" />
    <ellipse cx="169.932" cy="135.985" fill="#7C511C" rx="2.95121" ry="2.64661" />
    <ellipse cx="177.264" cy="144.523" fill="#D88D5C" rx="1.00852" ry=".81037" />
    <ellipse cx="177.294" cy="144.499" fill="#E7B268" rx=".97877" ry=".78646" />
    <ellipse cx="177.294" cy="144.499" fill="#E7B268" rx=".97877" ry=".78646" />
    <ellipse cx="171.302" cy="146.254" fill="#D88D5C" rx="1.58101" ry="1.27037" />
    <ellipse cx="171.348" cy="146.216" fill="#E7B268" rx="1.53437" ry="1.2329" />
    <ellipse cx="171.348" cy="146.216" fill="#E7B268" rx="1.53437" ry="1.2329" />
    <ellipse cx="177.132" cy="139.336" fill="#D88D5C" rx=".87677" ry=".7045" />
    <ellipse cx="177.158" cy="139.315" fill="#E7B268" rx=".85091" ry=".68372" />
    <ellipse cx="177.158" cy="139.315" fill="#E7B268" rx=".85091" ry=".68372" />
    <path
      fill="#C8C9C8"
      d="M157.054 134.56c.712-3.3-3.807-7.047-10.092-8.368-6.285-1.322-11.957.282-12.668 3.582-.711 3.3 3.807 7.047 10.093 8.368 6.285 1.322 11.956-.282 12.667-3.582Z"
    />
    <path
      fill="#B8B8B8"
      d="M156.352 132.738c-.733 1.76-4.716 2.071-7.966-1.036-2.935-2.795-4.822-5.073-4.507-5.798.105-.207 2.201-.725 6.394 1.035 1.153.518 2.62 1.139 3.354 1.761 1.992 1.656 3.25 2.795 2.725 4.038Z"
    />
  </SvgIcon>
)
